import { connect } from 'react-redux';
import { actions } from '../../../../../redux/modules/perfil';
import EditarPerfil from './EditarPerfil';


const ms2p = (state) => {
    return {
        ...state.perfil,
        me: state.login.me
    };
};

const md2p = { ...actions };

export default connect(ms2p, md2p)(EditarPerfil);
